import { render, staticRenderFns } from "./PaymentLogTable.vue?vue&type=template&id=5f70fcba"
import script from "./PaymentLogTable.vue?vue&type=script&lang=ts"
export * from "./PaymentLogTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports